var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-12 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 avp-logo"},[_c('AnimodLogo',{staticClass:"icon logo",attrs:{"alt":"Logo der Animod GmbH"}})],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Willkommen im Anfrage–Portal von Animod")])])
}]

export { render, staticRenderFns }